import { Controller } from "@hotwired/stimulus"

// Used to provide interaction for tabs where the content for all tabs is pre-loaded onto the page,
// and we just need to hide/show as appropriate.
export default class extends Controller {
  connect() {
    this.handles = this.element.querySelectorAll('[data-tab-handle]')
    this.bodies = this.element.querySelectorAll('[data-tab-body]')
    for (var i = 0; i < this.handles.length; i++) {
      var handle = this.handles[i];
      handle.addEventListener('click', this.onClick.bind(this));
    }
  }

  onClick(e) {
    e.preventDefault();
    var clickedHandle = e.target;
    var tabBodyId = clickedHandle.getAttribute('data-target');
    for (var i = 0; i < this.bodies.length; i++) {
      var body = this.bodies[i];
      if (body.id == tabBodyId) {
        body.classList.remove('hidden');
      } else {
        body.classList.add('hidden');
      }
    }

    clickedHandle.classList.add('font-bold');
    for (var i = 0; i < this.handles.length; i++) {
      var handle = this.handles[i];
      if (handle != clickedHandle) {
        handle.classList.remove('font-bold');
      }
    }
  }
}
